module.exports = __webpack_public_path__ + "img/MinAgeVsOwnsRing.935561c0.png";